import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import VendorSidebar from './VendorSidebar';
import { IoCloseSharp } from 'react-icons/io5';
import {  FaUpload,FaInfoCircle, FaEye, FaSave } from 'react-icons/fa';
import Navbar from '../components/navbar';
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

const UpdateProductVendor = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [smalldescription, setSmallDescription] = useState('');
  const [description, setDescription] = useState('');
  const [active, setActive] = useState(true);
  const [originalPrice, setOriginalPrice] = useState('');
  const [sellingPrice, setSellingPrice] = useState('');
  const [category, setCategory] = useState('');
  const [selectedSubCategory, setSelectedSubCategory] = useState('');
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);
  const [existingImages, setExistingImages] = useState([]);
  const [removedExistingImages, setRemovedExistingImages] = useState([]);
  const [images, setImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [message, setMessage] = useState('');
  const [keywords, setKeywords] = useState(['', '', '', '', '']);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      await fetchCategories();
      await fetchSubCategories();
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (subCategories.length > 0) {
      fetchProductDetails();
    }
  }, [subCategories]);

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/getCategoryHome`);
      if (res.data.status === 'ok') setCategories(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchSubCategories = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/getSubCategory`);
      if (res.data.status === 'ok') setSubCategories(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchProductDetails = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/GetproductVendor/${id}`);
      const data = response.data;

      if (data.status === 'ok') {
        const product = data.data;
        setName(product.name);
        setSlug(product.slug);
        setSmallDescription(product.smalldescription);
        setDescription(product.description);
        setActive(product.active);
        setOriginalPrice(product.originalPrice);
        setSellingPrice(product.sellingPrice);
        setCategory(product.category);
        setSelectedSubCategory(product.subcategory);
        setKeywords(product.keywords || ['', '', '', '', '']);

        const filtered = subCategories.filter(sub => sub.Category === product.category);
        setFilteredSubCategories(filtered);

        if (Array.isArray(product.image)) {
          setExistingImages(product.image.map(img => `${process.env.REACT_APP_API_URL}/${img}`));
        }
      } else {
        setMessage(data.message);
      }
    } catch (error) {
      setMessage('An error occurred: ' + error.message);
    }
  };

  const handleCategoryChange = (e) => {
    const selectedCategoryId = e.target.value;
    setCategory(selectedCategoryId);
    setSelectedSubCategory('');
    const filtered = subCategories.filter(sub => sub.Category === selectedCategoryId);
    setFilteredSubCategories(filtered);
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setImages(prev => [...prev, ...files]);

    files.forEach(file => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviews(prev => [...prev, reader.result]);
      };
      reader.readAsDataURL(file);
    });
  };

  const removeImage = (index) => {
    const updatedPreviews = [...imagePreviews];
    const updatedFiles = [...images];
    updatedPreviews.splice(index, 1);
    updatedFiles.splice(index, 1);
    setImagePreviews(updatedPreviews);
    setImages(updatedFiles);
  };

  const removeExistingImage = (index) => {
    const removedImage = existingImages[index];
    const filename = removedImage.replace(`${process.env.REACT_APP_API_URL}/`, '');
    setRemovedExistingImages(prev => [...prev, filename]);

    const updatedImages = [...existingImages];
    updatedImages.splice(index, 1);
    setExistingImages(updatedImages);
  };

  const handleKeywordChange = (index, value) => {
    const updatedKeywords = [...keywords];
    updatedKeywords[index] = value;
    setKeywords(updatedKeywords);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append('_id', id);
    formData.append('name', name);
    formData.append('slug', slug);
    formData.append('smalldescription', smalldescription);
    formData.append('description', description);
    formData.append('active', active);
    formData.append('originalPrice', originalPrice);
    formData.append('sellingPrice', sellingPrice);
    formData.append('category', category);
    formData.append('subCategory', selectedSubCategory);
    formData.append('removedImages', JSON.stringify(removedExistingImages));
    formData.append('keywords', JSON.stringify(keywords));

    images.forEach((img) => {
      formData.append('image', img);
    });

    try {
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/updateProductVendor`, formData);
      const data = response.data;

      if (data.status === 'ok') {
          toast.success('Product updated successfully!');
      
        navigate('/Vendor/AllProduct');
      } else {
        alert(data.message || 'Product update failed!');
      }
    } catch (error) {
      console.error('Error:', error);
      setMessage('An error occurred while updating the product.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <ToastContainer position="top-center" autoClose={3000} />
      <div className='main-container'>
        <VendorSidebar />

        <div className='content-area'>
          <div className="page-header">
            <div className="header-content">
              <h1 className="page-title">Update Product</h1>
              <div className="header-actions">
                <button className="help-btn">
                  <FaInfoCircle /> Help Center
                </button>
                <button className="feedback-btn">Your Feedback</button>
              </div>
            </div>
          </div>

          <form className="form-container-vendor" onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="form-content">
 <div className="form-section">
                <div className="section-header">
                  <h3>Category Selection</h3>
                </div>
              {/* Category */}
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label required">Category</label>
                  <select className="form-control" onChange={handleCategoryChange} value={category} required>
                    <option value="">Select Category</option>
                    {categories.map((cat) => (
                      <option key={cat._id} value={cat._id}>{cat.name}</option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label required">Sub Category</label>
                  <select className="form-control" value={selectedSubCategory} onChange={(e) => setSelectedSubCategory(e.target.value)} required>
                    <option value="">Select Subcategory</option>
                    {filteredSubCategories.map((sub) => (
                      <option key={sub._id} value={sub._id}>{sub.name}</option>
                    ))}
                  </select>
                </div>
              </div>
</div>
              {/* Name and Slug */}
                 {/* Primary Product Information */}
              <div className="form-section">
                <div className="section-header">
                  <h3>Primary Product Information</h3>
                  <p className="section-subtitle">Ensure accurate search results and make your product more attractive</p>
                </div>
              <div className="form-group">
                <label className="form-label required">Product Name</label>
                <input type='text' className="form-control" placeholder="Enter product name" value={name} onChange={(e) => setName(e.target.value)} />
              </div>

              <div className="form-group">
                <label className="form-label">Slug</label>
                <input type='text' className='form-control' value={slug} onChange={(e) => setSlug(e.target.value)} />
              </div>
    </div>
              {/* Keywords */}
              <div className="form-section">
                  <div className="section-header">
                <h3>Search Optimization Keywords</h3>
                </div>
                <div className="keywords-grid">
                  {keywords.map((keyword, index) => (
                    <div key={index} className="form-group">
                      <label className="form-label">{index < 2 ? `* Keyword ${index + 1}` : `Keyword ${index + 1}`}</label>
                      <input
                        type="text"
                        className="form-control"
                        value={keyword}
                        onChange={(e) => handleKeywordChange(index, e.target.value)}
                        maxLength="50"
                      />
                      <div className="char-count">{keyword.length}/50</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Images */}
              <div className="form-section">
                <div className="section-header">
                  <h3>Product Images</h3>
                  <p className="section-subtitle">Upload high-quality images to showcase your product</p>
                </div>
                   <div className="image-upload-area">
                <div className="upload-grid">
                  {existingImages.map((url, index) => (
                    <div key={`existing-${index}`} className="image-preview-card">
                      <img src={url} alt={`Existing ${index + 1}`} />
                      <span className="existing-image-label">Saved</span>
                      <button type="button"   className="remove-image-btn" onClick={() => removeExistingImage(index)}><IoCloseSharp /></button>
                    </div>
                  ))}

                  {imagePreviews.map((preview, index) => (
                    <div key={`preview-${index}`} className="image-preview-card">
                      <img src={preview} alt={`Preview ${index + 1}`} />
                      <button type="button"   className="remove-image-btn" onClick={() => removeImage(index)}><IoCloseSharp /></button>
                    </div>
                  ))}

                  {(existingImages.length + imagePreviews.length) < 10 && (
                    <div className="upload-placeholder">
                      <input type="file" accept="image/*" multiple onChange={handleImageUpload} className="hidden-file-input" id="image-upload" />
                      <label htmlFor="image-upload" className="upload-label">
                                               <FaUpload className="upload-icon" />
                                               <span>Upload Images</span>
                                               <small>PNG, JPG, GIF up to 10MB</small>
                                             </label>
                    </div>
                  )}
                </div>
                 <div className="upload-info">
                    <p><strong>Image Requirements:</strong></p>
                    <ul>
                      <li>Minimum resolution: 800x800 pixels</li>
                      <li>Maximum file size: 10MB per image</li>
                      <li>Supported formats: PNG, JPG, GIF</li>
                      <li>Upload up to 10 images</li>
                    </ul>
                  </div>
                </div>
              </div>
  {/* Product Details */}
              <div className="form-section">
                <div className="section-header">
                  <h3>Product Details</h3>
                </div>
              {/* Price and Description */}
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label required">Original Price (₹)</label>
                  <input type='number' className='form-control' value={originalPrice} onChange={(e) => setOriginalPrice(e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label required">Selling Price (₹)</label>
                  <input type='number' className='form-control' value={sellingPrice} onChange={(e) => setSellingPrice(e.target.value)} />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label required">Short Description</label>
                <textarea className='form-control' placeholder="Brief description..." maxLength="300" value={smalldescription} onChange={(e) => setSmallDescription(e.target.value)} />
              </div>

              <div className="form-group">
                <label className="form-label required">Detailed Description</label>
                <textarea className="form-control" rows="6" value={description} onChange={(e) => setDescription(e.target.value)} />
              </div>
 
              {/* Status */}
              <div className="form-group">
                <label className="form-label">Product Status</label>
                <div>
                  <label>
                    <input type="radio" name="active" value="true" checked={active === true} onChange={() => setActive(true)} /> Active
                  </label>
                  <label style={{ marginLeft: '20px' }}>
                    <input type="radio" name="active" value="false" checked={active === false} onChange={() => setActive(false)} /> Inactive
                  </label>
                </div>
              </div>
</div>
              {/* Submit */}
              <div className="form-actions">
                <button type="button" className="btn btn-secondary"><FaEye /> Preview</button>
                <button type="button" className="btn btn-outline"><FaSave /> Save Draft</button>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default UpdateProductVendor;
